import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { CatalogValueEntity } from './catalog-value.entity';
import { JobEntity } from './job.entity';
import { WholesalerEntity } from './wholesaler.entity';

/**
 * PD-17109 — a competitor (a `wholesaler` row) on a job, the won work for one
 * customer: the scope it supplies or quotes (product groups, in words), where
 * it stands (the tenant-editable Competitor Statuses list), its price only
 * when a rep gave one, and a note in the rep's words.
 *
 * A job is one customer's, so the customer is the job's and its visibility
 * applies. Separate from opportunity_competitor, which records who quoted the
 * bid the job was won from (Job Detail shows those as fromOpportunity).
 *
 * One row per competitor per job; a row taken off is soft-deleted and comes
 * back on the next add.
 *
 * SM1 exposure: none (a new table).
 */
@Index('job_competitor__job_competitor', ['fkJobId', 'fkWholesalerId'], { unique: true })
@Index('job_competitor__fk_wholesaler__id', ['fkWholesalerId'], {})
@Entity('job_competitor')
export class JobCompetitorEntity extends BaseEntity {
	@Column('int', { name: 'fk_job__id', unsigned: true })
	public fkJobId!: number;

	@Column('int', { name: 'fk_wholesaler__id', unsigned: true })
	public fkWholesalerId!: number;

	@Column('varchar', { name: 'scope', length: 255, nullable: true })
	public scope!: string | null;

	/** A Competitor Statuses catalog value. */
	@Column('int', { name: 'fk_catalog_value__id_status', unsigned: true, nullable: true })
	public statusId!: number | null;

	/** Their price, only when a rep gave one. */
	@Column('decimal', { name: 'theirPrice', precision: 15, scale: 2, nullable: true })
	public theirPrice!: string | null;

	@Column('varchar', { name: 'note', length: 2000, nullable: true })
	public note!: string | null;

	@ManyToOne(() => JobEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_job__id', referencedColumnName: 'id' }])
	public job!: JobEntity;

	@ManyToOne(() => WholesalerEntity, { onDelete: 'RESTRICT', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_wholesaler__id', referencedColumnName: 'id' }])
	public competitor!: WholesalerEntity;

	@ManyToOne(() => CatalogValueEntity, { onDelete: 'SET NULL', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_catalog_value__id_status', referencedColumnName: 'id' }])
	public status!: CatalogValueEntity | null;
}
